<template>
    <div>
        <!-- 预留实例购买 -->
        <div v-show="isPrevious">
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('ApprovalTask.reservedInstancePurchase')}}</p>
                        <!-- 关联案例ID -->
                        <FormItem :label="$t('ApprovalTask.associatedCaseID')" :label-width="90">
                            <Row>
                                <Col span="24">{{ticketEntityId}}</Col>
                            </Row>
                        </FormItem>
                        <!-- 上级节点内容 -->
                        <FormItem :label="$t('ApprovalTask.contentOfTheParentNode')" :label-width="90">
                            <Table :no-data-text="$t('common.noData')" :columns="listApprovalRecordColumn" :data="listApprovalRecordDate" style="width:100%;"></Table>
                        </FormItem>
                        <!-- 匹配类型 -->
                        <FormItem :label="$t('ApprovalTask.matchType')" :label-width="90">
                            <Row>
                                <Col span="24">
                                    <RadioGroup v-model="customizeReservedInstanceSaveType" @on-change="changeCustomize(customizeReservedInstanceSaveType)">
                                        <Radio v-for="list in customizeReservedInstanceSaveTypeList" :label="list.customizeReservedInstanceSaveType" :key="list.value">{{list.label}}</Radio>
                                    </RadioGroup>
                                </Col>
                            </Row>
                        </FormItem>
                        <!-- 预留实例购买清单 -->
                        <FormItem :label="$t('ApprovalTask.purchaseList')" :label-width="90">
                            <Table :no-data-text="$t('common.noData')" ref="selection" @on-select-all="selectAllReservedInstance"
                                   @on-select-all-cancel="cancelAllReservedInstance" @on-select="checkedReservedInstance" @on-selection-change="getSelectionReserved" @on-select-cancel="cancelReserved" :loading="reservedLoading" :columns="columnsIsBuyReservedInstances" :data="isBuyReservedInstancesData" style="width:100%;">
                                <template slot="actualPurchasedQuantity" slot-scope="props">
                                    <Form :ref="'formDynamic'+props.idx" :model="props.row">
                                        <!-- 当匹配类型为"原始数据"或者linuxServerFlag为"false" 显示"数量"字段 -->
                                        <FormItem prop="actualPurchasedQuantity" :rules="rules.instanceCount" v-if="customizeReservedInstanceSaveType==0||props.row.linuxServerFlag==false">
                                            <Input v-model="props.row.actualPurchasedQuantity" size="small" number @on-change="changeActualPurchasedQuantity(props.idx,props.row,props.row.actualPurchasedQuantity)" @on-blur="blurInstanceCount(props.idx,props.row,props.row.actualPurchasedQuantity)" type="number"></Input>
                                        </FormItem>
                                        <!-- 当匹配类型为"标准化因子"且linuxServerFlag为"true" 显示"标准化因子"字段 -->
                                        <FormItem prop="actualPurchasedQuantity" :rules="rules.normalizationFactor" v-else-if="customizeReservedInstanceSaveType==1&&props.row.linuxServerFlag==true">
                                            <Input v-model="props.row.actualPurchasedQuantity" size="small" number @on-change="changeActualPurchasedQuantity(props.idx,props.row,props.row.actualPurchasedQuantity)" @on-blur="blurNormalizationFactor(props.idx,props.row,props.row.actualPurchasedQuantity)" type="number"></Input>
                                        </FormItem>
                                    </Form>
                                </template>
                            </Table>
                        </FormItem>
                    </Card>
                </Col>
            </Row>
        </div>
        <!-- 预留实例购买清单 -->
        <div v-show="isNext">
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('ApprovalTask.reservedInstancePurchaseList')}}</p>
                        <!-- 关联案例ID -->
                        <FormItem :label="$t('ApprovalTask.associatedCaseID')" :label-width="90">
                            <Row>
                                <Col span="24">{{ticketEntityId}}</Col>
                            </Row>
                        </FormItem>
                        <!-- 匹配类型 -->
                        <FormItem :label="$t('ApprovalTask.matchType')" :label-width="90">
                            <Row>
                                <Col span="24">{{reservedInstanceSaveType}}</Col>
                            </Row>
                        </FormItem>
                        <!-- 预留实例购买清单 -->
                        <FormItem :label="$t('ApprovalTask.purchaseList')" :label-width="90">
                            <Table :no-data-text="$t('common.noData')" :columns="reservedListColumns" :data="reservedList" style="width:100%;"></Table>
                        </FormItem>
                        <!-- 提示 -->
                        <FormItem label="" :label-width="90" v-show="showTip">
                            <Row style="line-height:17px;">
                                <Col span="24">
                                    <Checkbox v-model="disclaimer" @on-change="changeDisclaimer">{{$t('ApprovalTask.tip')}}</Checkbox>
                                </Col>
                            </Row>
                        </FormItem>
                    </Card>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ReservedInstance',
        props: ['reservedInstanceForm'],
        data() {
            // 验证数量
            var validCheckInstanceCount = (rule, value, callback) => {
                //不能大于当前数量
                if(this.flagInstanceCount==1){
                    return callback(new Error("应≤当前数量"));
                }else if(this.flagInstanceCount==2){
                    callback();
                }
            };

            // 验证标准化接口
            var validCheckNormalizationFactor = (rule, value, callback) => {
                setTimeout(() => {
                    // 不能大于当前标准化数量
                    if(this.flagNormalizationFactor==1){
                        return callback(new Error("应≤当前标准化数量"));
                    }else if(this.flagNormalizationFactor==2){
                        callback();
                    }else{
                        return callback(new Error('验证失败'));
                    }
                }, 1000)
            };
            return {
                showTip:false,
                disclaimer: true,// 提示
                flagInstanceCount:-1,//数量
                flagNormalizationFactor:-1,//标准化数量
                isNext: false,
                isPrevious: true,//上一步 下一步
                reservedInstanceSaveType:'',
                reservedLoading:false,
                selectionReserved:[],
                newReservedDataList:[],
                selection:[],
                silverLiningNode:'',
                ticketEntityId: '',//预留实例购买
                customizeReservedInstanceSaveType:parseInt(this.$route.query.customizeReservedInstanceSaveType),
                customizeReservedInstanceSaveTypeList: [{
                    label: this.$t('ApprovalTask.rawData'),
                    value: 'amount',
                    customizeReservedInstanceSaveType: 0
                },{
                    label: this.$t('ApprovalTask.standardizedQuantity'),
                    value: 'normalizationFactors',
                    customizeReservedInstanceSaveType: 1
                }],//匹配类型
                formDynamic: {},
                rules: {
                    instanceCount: [
                        {required: true, type: 'number', message: '请输入数字', trigger: 'blur'},
                        {type: 'number', min: 1, message: '应大于1', trigger: 'blur'},
                        {validator: validCheckInstanceCount, trigger: 'blur'}
                    ],
                    normalizationFactor: [
                        {required: true, type: 'number', message: '请输入数字', trigger: 'blur'},
                        {type: 'number', min: 1, message: '应大于1', trigger: 'blur'},
                        {validator: validCheckNormalizationFactor, trigger: 'blur'}
                    ]
                },//表单验证
                columnsIsBuyReservedInstances: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('ApprovalTask.accountName'),
                    key: 'accountName',
                    minWidth: 150
                },
                {
                    title: this.$t('ApprovalTask.accountId'),
                    key: 'accountIdStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.region'),
                    key: 'region',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceCount'),
                    key: 'instanceCount',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.normalizationFactor'),
                    key: 'normalizationFactor',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.actualPurchasedQuantity'),
                    minWidth: 200,
                    render: (h, params) => {
                        this.isBuyReservedInstancesData[params.index].actualPurchasedQuantity = params.row.actualPurchasedQuantity;
                        return h('div',
                            this.$refs.selection.$scopedSlots.actualPurchasedQuantity({
                                row: params.row,
                                idx: params.row._index
                            })
                        )
                    }
                },
                {
                    title: this.$t('ApprovalTask.instanceType'),
                    key: 'instanceType',
                    minWidth: 140,
                },
                {
                    title: this.$t('ApprovalTask.price'),
                    key: 'priceDescription',
                    minWidth: 180,
                },
                {
                    title: this.$t('ApprovalTask.productDescription'),
                    key: 'productDescription',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceTenancy'),
                    key: 'instanceTenancyStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringType'),
                    key: 'offeringTypeStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringClass'),
                    key: 'offeringClassStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.endDate'),
                    key: 'endDateStr',
                    minWidth: 160,
                },
                {
                    title: this.$t('ApprovalTask.duration'),
                    key: 'durationStr',
                    minWidth: 140
                }],//预留实例购买
                reservedListColumns: [
                {
                    title: this.$t('ApprovalTask.accountName'),
                    key: 'accountName',
                    minWidth: 150
                },
                {
                    title: this.$t('ApprovalTask.accountId'),
                    key: 'accountIdStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.region'),
                    key: 'region',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceCount'),
                    key: 'instanceCount',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.normalizationFactor'),
                    key: 'normalizationFactor',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.actualPurchasedQuantity'),
                    key:'actualPurchasedQuantity',
                    minWidth: 110
                },
                {
                    title: this.$t('ApprovalTask.instanceType'),
                    key: 'instanceType',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.price'),
                    key: 'priceDescription',
                    minWidth: 180,
                },
                {
                    title: this.$t('ApprovalTask.productDescription'),
                    key: 'productDescription',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceTenancy'),
                    key: 'instanceTenancyStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringType'),
                    key: 'offeringTypeStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringClass'),
                    key: 'offeringClassStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.endDate'),
                    key: 'endDateStr',
                    minWidth: 140,
                },
                {
                    title: this.$t('ApprovalTask.duration'),
                    key: 'durationStr',
                    minWidth: 140
                }],//预留实例购买清单
                isBuyReservedInstancesData: [],
                reservedList:[],
                listApprovalRecordColumn:[{
                    title: this.$t('ApprovalTask.accountName'),
                    key: 'accountName',
                    minWidth: 150
                },
                {
                    title: this.$t('ApprovalTask.accountId'),
                    key: 'accountIdStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.region'),
                    key: 'region',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceCount'),
                    key: 'instanceCount',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.normalizationFactor'),
                    key: 'normalizationFactor',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.actualPurchasedQuantity'),
                    key:'actualPurchasedQuantity',
                    minWidth: 110
                },
                {
                    title: this.$t('ApprovalTask.instanceType'),
                    key: 'instanceType',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.price'),
                    key: 'priceDescription',
                    minWidth: 180,
                },
                {
                    title: this.$t('ApprovalTask.productDescription'),
                    key: 'productDescription',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceTenancy'),
                    key: 'instanceTenancyStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringType'),
                    key: 'offeringTypeStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringClass'),
                    key: 'offeringClassStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.duration'),
                    key: 'durationStr',
                    minWidth: 140
                }],
                listApprovalRecordDate:[],//上级节点内容
                selectedDateList:[]
            }
        },
        mounted: function () {
            this.approvalReviewInstance();
            // 返回上级节点内容
            this.listApprovalRecord();
        },
        methods: {
            /**********************提示******************************/
            // 切换提示
            changeDisclaimer:function(){
                if(this.disclaimer==true){
                    this.reservedInstanceForm.isDisable = false;
                }else if(this.disclaimer==false){
                    this.reservedInstanceForm.isDisable = true;
                }
            },
            /**********************表格自定义验证******************************/
            // 数量焦点事件
            blurInstanceCount:function(index,row,val){
                if(val>row.instanceCount){
                    this.flagInstanceCount=1;
                }else if(((val<row.instanceCount)||(val=row.instanceCount))&&val>0){
                    //清空数组
                    this.newReservedDataList = [];
                    this.flagInstanceCount=2;
                    // 动态计算价格
                    this.$api.reservedInstance.calculateReservedInstancePrice({
                        "accountId": row.accountId,
                        "region": row.region,
                        "productDescription": row.productDescription,
                        "instanceType": row.instanceType,
                        "duration": row.duration,
                        "instanceCount": val,
                        "instanceTenancy": row.instanceTenancy,
                        "offeringClass": row.offeringClass,
                        "offeringType": row.offeringType,
                        "scope": row.scope,
                    })
                    .then(res => {
                        // RI价格
                        this.isBuyReservedInstancesData[index].priceDescription = res.data;
                        const dataList = [];
                        for (var i = 0; i < this.isBuyReservedInstancesData.length; i++) {
                            if (this.isBuyReservedInstancesData[i]._checked) {
                                dataList.push(this.isBuyReservedInstancesData[i]);
                            }
                        }
                        this.getSelectionReserved(dataList);
                        this.$Message.success('RI价格修改成功');
                    })
                }
                return this.flagInstanceCount;
            },
            // 标准化数量焦点事件
            blurNormalizationFactor:function(index,row,val){
                this.flagNormalizationFactor=-1;
                if(val>row.normalizationFactor){
                    this.flagNormalizationFactor=1;
                }else if(((val<row.normalizationFactor)||(val=row.normalizationFactor))&&val>0){
                    // 验证标准化数量接口
                    this.$api.reservedInstance.verifyReservedInstanceNormalizationFactor({
                        "reservedInstanceNormalizationFactor":val,
                        "instanceType":row.instanceType
                    })
                    .then(res => {
                        if (res.status == 200) {
                            this.flagNormalizationFactor=2;
                        }
                    })
                }
                return this.flagNormalizationFactor;
            },
            /**********************返回上级节点内容******************************/
            listApprovalRecord:function(){
                this.$api.resourceReservedInstanceApprovalRecord.listApprovalRecord({
                    "processTaskId":this.$route.query.id
                })
                .then(res => {
                    this.listApprovalRecordDate=res.data;
                })
            },
            /**********************预留实例购买******************************/
            // 上一步
            previous: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            // 查看预留实例购买详情
            approvalReviewInstance:function(){
                this.isBuyReservedInstancesData=[];
                this.ticketEntityId='';
                this.reservedLoading=true;

                // 审批
                this.$api.processTask.approvalReview({
                    "processTaskId":this.$route.query.id,
                    "customizeReservedInstanceSaveType":this.customizeReservedInstanceSaveType
                })
                .then(res => {
                    if(this.$route.query.type=='预留实例购买'){
                        this.reservedLoading=false;
                        // 关联案例ID
                        this.ticketEntityId=res.data.purchaseReservedInstance.ticketEntityId;
                        // 预留实例购买清单
                        this.isBuyReservedInstancesData=res.data.purchaseReservedInstance.waitingForPurchaseReservedInstanceDTOs;
                        this.silverLiningNode=res.data.purchaseReservedInstance.silverLiningNode;
                        // 清空数组
                        this.newReservedDataList = [];
                        // 选中数组
                        this.selectedDateList=[];
                        // 是否购买
                        if(res.data.purchaseReservedInstance.silverLiningNode==true){
                            this.isNext = true;
                            this.isPrevious = false;
                        }else if(res.data.purchaseReservedInstance.silverLiningNode==false){
                            this.isNext = false;
                            this.isPrevious = true;
                            var isBuyReservedInstancesData=this.isBuyReservedInstancesData;
                            // 可编辑
                            for (var i = 0; i < isBuyReservedInstancesData.length; i++) {
                                this.isBuyReservedInstancesData[i]._checked = this.isBuyReservedInstancesData[i].selected;
                                if(this.isBuyReservedInstancesData[i]._checked = this.isBuyReservedInstancesData[i].selected){
                                    var tableReservedCopy={
                                        "accountName": isBuyReservedInstancesData[i].accountName,
                                        "accountIdStr": isBuyReservedInstancesData[i].accountIdStr,
                                        "instanceTenancyStr": isBuyReservedInstancesData[i].instanceTenancyStr,
                                        "offeringTypeStr": isBuyReservedInstancesData[i].offeringTypeStr,
                                        "offeringClassStr": isBuyReservedInstancesData[i].offeringClassStr,
                                        "durationStr": isBuyReservedInstancesData[i].durationStr,
                                        "linuxServerFlag": isBuyReservedInstancesData[i].linuxServerFlag,
                                        "accountId": isBuyReservedInstancesData[i].accountId,
                                        "duration": isBuyReservedInstancesData[i].duration,
                                        "instanceTenancy": isBuyReservedInstancesData[i].instanceTenancy,
                                        "instanceType": isBuyReservedInstancesData[i].instanceType,
                                        "offeringClass": isBuyReservedInstancesData[i].offeringClass,
                                        "offeringType": isBuyReservedInstancesData[i].offeringType,
                                        "productDescription": isBuyReservedInstancesData[i].productDescription,
                                        "region": isBuyReservedInstancesData[i].region,
                                        "ticketId": isBuyReservedInstancesData[i].ticketId,
                                        "scope":isBuyReservedInstancesData[i].scope,
                                        "priceDescription":isBuyReservedInstancesData[i].priceDescription,
                                        "instanceCount":isBuyReservedInstancesData[i].instanceCount,
                                        "normalizationFactor":isBuyReservedInstancesData[i].normalizationFactor,
                                        "actualPurchasedQuantity":isBuyReservedInstancesData[i].actualPurchasedQuantity,
                                        "endDateStr":isBuyReservedInstancesData[i].endDateStr
                                    };
                                    if(this.customizeReservedInstanceSaveType==0||(this.customizeReservedInstanceSaveType==1&&isBuyReservedInstancesData[i].linuxServerFlag==false)){
                                        tableReservedCopy.id=isBuyReservedInstancesData[i].id;
                                    }
                                    this.newReservedDataList.push(tableReservedCopy);
                                    // 选中数组
                                    this.selectedDateList.push(tableReservedCopy);
                                }
                            }
                        }
                    }
                })
            },
            // 切换预留实例匹配类型
            changeCustomize:function(val){
                this.customizeReservedInstanceSaveType=val;
                this.approvalReviewInstance();
            },
            /*****************单选****************************/
            // 当前选择checkbox
            getSelectionReserved: function (selection) {
                this.selectionReserved = selection;
                //清空数组
                this.newReservedDataList = [];
                for (var i = 0; i < this.selectionReserved.length; i++) {
                    var tableReservedCopy={
                        "accountName": this.selectionReserved[i].accountName,
                        "accountIdStr": this.selectionReserved[i].accountIdStr,
                        "instanceTenancyStr": this.selectionReserved[i].instanceTenancyStr,
                        "offeringTypeStr": this.selectionReserved[i].offeringTypeStr,
                        "offeringClassStr": this.selectionReserved[i].offeringClassStr,
                        "durationStr": this.selectionReserved[i].durationStr,
                        "linuxServerFlag": this.selectionReserved[i].linuxServerFlag,
                        "accountId": this.selectionReserved[i].accountId,
                        "duration": this.selectionReserved[i].duration,
                        "instanceTenancy": this.selectionReserved[i].instanceTenancy,
                        "instanceType": this.selectionReserved[i].instanceType,
                        "offeringClass": this.selectionReserved[i].offeringClass,
                        "offeringType": this.selectionReserved[i].offeringType,
                        "productDescription": this.selectionReserved[i].productDescription,
                        "region": this.selectionReserved[i].region,
                        "ticketId": this.selectionReserved[i].ticketId,
                        "scope":this.selectionReserved[i].scope,
                        "priceDescription":this.selectionReserved[i].priceDescription,
                        "instanceCount":this.selectionReserved[i].instanceCount,
                        "normalizationFactor":this.selectionReserved[i].normalizationFactor,
                        "actualPurchasedQuantity":this.selectionReserved[i].actualPurchasedQuantity,
                        "endDateStr":this.selectionReserved[i].endDateStr
                    };

                    if(this.customizeReservedInstanceSaveType==0||(this.customizeReservedInstanceSaveType==1&&this.selectionReserved[i].linuxServerFlag==false)){
                        tableReservedCopy.id=this.selectionReserved[i].id;
                    }
                    this.newReservedDataList.push(tableReservedCopy);
                }
            },
            // 取消选中某一项时触发
            cancelReserved: function (selection, row) {
                const dataList  = JSON.parse(JSON.stringify(this.isBuyReservedInstancesData));
                if (row.id == undefined) {
                    // linux 当前取消行中的instanceType和所有数组里的instanceType匹配 相等则把checkbox变为false
                    const index = dataList.findIndex(item => item.instanceType == row.instanceType);
                    this.isBuyReservedInstancesData[index]._checked = false;
                } else{
                    // not linux
                    const index = dataList.findIndex(item => item.id == row.id);
                    this.isBuyReservedInstancesData[index]._checked = false;
                }
            },
            // 选中预留实例
            checkedReservedInstance: function (selection, row) {
                const dataList  = JSON.parse(JSON.stringify(this.isBuyReservedInstancesData));
                if (row.id == undefined) {
                    // linux 当前取消行中的instanceType和所有数组里的instanceType匹配 相等则把checkbox变为false
                    const index = dataList.findIndex(item => item.instanceType == row.instanceType);
                    this.isBuyReservedInstancesData[index]._checked = true;
                } else{
                    // not linux
                    const index = dataList.findIndex(item => item.id == row.id);
                    this.isBuyReservedInstancesData[index]._checked = true;
                }
            },
            // 全选事件
            selectAllReservedInstance: function () {
                for (var i = 0; i < this.isBuyReservedInstancesData.length; i++) {
                    this.isBuyReservedInstancesData[i]._checked = true;
                }
            },

            // 全部取消事件
            cancelAllReservedInstance: function () {
                for (var i = 0; i < this.isBuyReservedInstancesData.length; i++) {
                    this.isBuyReservedInstancesData[i]._checked = false;
                }
            },
            /**********************预留实例购买清单*****************************/
            // 下一步
            next: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 匹配类型
                this.reservedInstanceSaveType=this.customizeReservedInstanceSaveType== 0 ? "原始数据" : "标准化数量";
                // 预留实例购买清单
                this.reservedList=this.newReservedDataList;
            },
            /**********************表单验证*****************************/
            // 改变建议购买数量
            changeActualPurchasedQuantity:function(index,row,val){
                row.actualPurchasedQuantity = val;
                // 改变时触发改变事件 保证获取到编辑完的值以及不破坏勾选框编辑内容
                this.isBuyReservedInstancesData[index].actualPurchasedQuantity = row.actualPurchasedQuantity;
                const dataList = [];
                for (var i = 0; i < this.isBuyReservedInstancesData.length; i++) {
                    if (this.isBuyReservedInstancesData[i]._checked) {
                        dataList.push(this.isBuyReservedInstancesData[i]);
                    }
                }
                this.getSelectionReserved(dataList);
            }
        }
    }
</script>

<style>
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .ivu-form .ivu-form-label-right .ivu-form-item-error-tip
    {
        margin-top: -25px !important;
        margin-left: 42px !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/approval_task/approval_type/reserved_instance/ReservedInstance.vue